var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLivy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 151,
    viewBox: "0 0 142 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3149 150.705C11.5321 142.734 8.73783 134.762 5.97792 126.785C3.96237 120.964 1.99264 115.126 0 109.294C5.91493 109.294 11.8356 109.294 17.7505 109.294C19.8348 116.582 21.9247 123.869 24.009 131.15L24.5816 131.058C26.5055 123.806 28.4294 116.547 30.3476 109.294C35.69 109.294 41.038 109.294 46.3804 109.294C42.6585 119.503 38.9137 129.707 35.2147 139.927C33.9207 143.499 32.7297 147.111 31.4928 150.705H14.3149Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.969 150.705C108.911 146.605 108.969 142.498 108.738 138.403C108.652 136.764 108.26 134.987 107.489 133.555C103.079 125.423 98.5136 117.371 94 109.296C100.333 109.296 106.666 109.296 112.999 109.296C114.72 113.357 116.441 117.417 118.462 122.191L123.937 109.296C129.309 109.296 134.686 109.285 140.057 109.319C140.443 109.319 140.823 109.676 141.209 109.871C141.007 110.055 140.742 110.211 140.61 110.435C135.981 118.47 131.358 126.51 126.758 134.556C126.43 135.125 126.033 135.781 126.033 136.396C126.05 141.164 126.159 145.932 126.24 150.7H108.969V150.705Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4762 0V35.2431H43V50H0V0H20.4762Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128 0V50H108V0H128Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivy);
export default __webpack_public_path__ + "static/media/livy.7ec2012a8cb633228b5d8cb316f6ecef.svg";
export { ForwardRef as ReactComponent };